/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type DeleteProjectInput = {
    readonly projectId: string;
    readonly clientMutationId?: string | null;
};
export type DeleteProjectMutationVariables = {
    readonly input: DeleteProjectInput;
};
export type DeleteProjectMutationResponse = {
    readonly deleteProject: {
        readonly deletedProjectId: string | null;
    } | null;
};
export type DeleteProjectMutation = {
    readonly response: DeleteProjectMutationResponse;
    readonly variables: DeleteProjectMutationVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "DeleteProjectInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "deleteProject",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "DeleteProjectPayload",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "deletedProjectId",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "DeleteProjectMutation",
            "type": "Mutations",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "DeleteProjectMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "DeleteProjectMutation",
            "id": "app-buyer-misc/230.0.0-2019-08-28T11:54:11.732Z/DeleteProjectMutation",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'c756f98a74a87689ac702bf61c5d65af';
export default node;
